import invoking from './invoking';

/**
 * 是否显示原生音频播放器的入口
 * @param {boolean} isShow 是否显示
 */
export function setAudioEntry(isShow = false) {
    invoking({
        action: 'showAudioPlayerEntry',
        data: {
            isShow
        }
    });
}

/**
 * 通知客户端同步音频状态
 */
export function audioStatusShare() {
    invoking({
        action: 'audioStatusShare'
    });
}

/**
 * 设置音频数据，同时通知客户端同步部分音频状态
 * @param options 音频数据
 */
export function pageViewReady(options) {
    setAudioData('pageViewReady', options);
}

/**
 * 更新音频数据
 * @param {*} options 音频数据
 */
export function audioDataUpdate(options) {
    setAudioData('audioDataUpdate', options);
}

/**
 * 设置音频数据
 * @param action 方法名称
 * @param options 客户端音频播放所需参数
 * @param options.playingType 播放类型
 * @param options.columnId 专辑 id
 * @param options.playList 播放列表
 * @param options.needStatus 是否需要同步状态标识
 * @param options.cover 播放封面
 * @param options.thumbnail 播放缩略图
 * @param options.author 音频作者
 * @param options.backUrl 返回按钮的 wap 页面链接
 * @param options.backTitle 返回按钮的标题
 * @param options.index 音频索引
 * @param options.shareInfo 原生播放页分享配置
 */
function setAudioData(action, options) {
    const data = {
        playingType: '',
        columnId: '',
        playList: [],
        needStatus: true,
        cover: '',
        thumbnail: '',
        author: '妈妈网孕育',
        backUrl: location.href,
        backTitle: '返回',
        index: 0,
        shareInfo: {},
        courseId: ''
    };
    for (const key in data) {
        data[key] = options[key] || data[key];
    }
    data.courseId = data.courseId || data.columnId;
    invoking({
        action,
        data
    });
}

/**
 * 调用 app 原生播放器进行播放
 * @param {number} index 当前音频的位置索引
 */
export function audioPlay(index, ext = '') {
    invoking({
        action: 'audioPlay',
        data: {
            index,
            ext
        }
    });
}

/**
 * 暂停后重新播放
 * @param {number} index 当前音频的在播放列表中的位置索引
 */
export function audioResume(index) {
    invoking({
        action: 'audioResume',
        data: {
            index
        }
    });
}

/**
 * 暂停播放当前音频
 * @param {number} index 暂停当前音频的播放
 */
export function audioPause(index) {
    invoking({
        action: 'audioPause',
        data: {
            index
        }
    });
}

/**
 * 停止音频播放
 * @param {number} index 当前播放音频在播放列表中的位置索引
 */
export function audioStop(index) {
    invoking({
        action: 'audioStop',
        data: {
            index
        }
    });
}

/**
 * 播放上一条音频
 */
export function audioPlayPre(ext = '') {
    invoking({
        action: 'audioPlayPre',
        data: {
            ext
        }
    });
}

/**
 * 播放下一条音频
 */
export function audioPlayNext(ext = '') {
    invoking({
        action: 'audioPlayNext',
        data: {
            ext
        }
    });
}

/**
 * 设置播放进度
 * @param {number} index 当前音频在播放列表中的位置索引
 * @param {number} currentTime 播放进度，单位秒
 */
export function audioSeekProgress({index, currentTime}) {
    invoking({
        action: 'audioSeekProgress',
        data: {
            index,
            currentTime
        }
    });
}

/**
 * 设置闹钟
 * @param {Object} 闹钟配置数据
 */
export function audioClockUpdate({status = 0, onlyCurrent = 0, second = 0}) {
    invoking({
        action: 'audioClockUpdate',
        data: {
            status,
            onlyCurrent,
            second
        }
    });
}

/**
 * 更新音频特定状态
 * @param {Object} 音频状态数据
 */
export function audioConditionUpdate({columnId, audioId, ...rest}) {
    invoking({
        action: 'audioConditionUpdate',
        data: {
            columnId,
            audioId,
            ...rest
        }
    });
}

/**
 * 插入一条音频，等当前音频播放完后再播放
 * @param {Object} audioData 音频数据
 */
export function audioInsertAfter(audioData) {
    invoking({
        action: 'audioInsertAfter',
        data: audioData
    });
}

/**
 * 更新不需要播放的音频列表（针对儿歌故事和好孕电台）
 * @param {string} type 类型
 * @param {Object} audioData 音频数据
 */
export function audioRemovedListUpdate({type, audioData}) {
    invoking({
        action: 'audioRemovedListUpdate',
        data: {
            type,
            audioData
        }
    });
}
